import React, { Component } from 'react';
import queryString from 'query-string';
import classNames from 'classnames';
import HeaderWrapper from '../../../../Components/HeaderWrapper/HeaderWrapper';
import { NewItemIcon } from '../../../../Assets/Navigation/NavigationIcons';
import ItemDetails from '../../../../Pages/Items/ItemDetails';

import {
  // NewItemIcon,
  restRequest,
  ListTable,
  MdClose,
  setObjInLS,
  // ItemDetails,
  checkError,
  AccessDenied,
} from './';
import '../Ecommerce.css';
class SyncStockDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      dataExpanded: [],
      showExportModal: false,
      organizationCurrency: {},
      totalPage: 1,
      currentPage: 1,
      viewPerPage: 20,
      totalRecords: 0,
      currentFilter: 'all',
      orderBy: 'asc',
      sortFilter: 'created_at',
      preference: {},
      search: '',
      accessDenied: false,
      overallHisotyFilter: '',
      currentStore: {},
    };
    this.getID = this.getID.bind(this);
  }

  componentDidMount() {
    document.title = 'Sync Woo Commerce Store History';
    this.fetchDataWithQueryString();
  }

  componentDidUpdate() {
    this.handleOnUpdateQueryString();
  }

  fetchDataWithQueryString() {
    const { filter, page, sort, orderBy, view, search } =
      this.parseQueryString();
    this.setState(
      {
        sortFilter: sort,
        currentFilter: filter,
        currentPage: parseInt(page),
        orderBy: orderBy,
        viewPerPage: parseInt(view),
        search: search,
      },
      () => this.fetchData()
    );
  }

  parseQueryString() {
    const query = queryString.parse(this.props.location.search);
    let filter = query.filter || 'all';

    let sort = query.sort || 'created_at';

    let orderBy = query.orderBy || 'desc';

    let page = parseInt(query.page) || 1;
    // if (!page) page = 1;
    let view = parseInt(query.view) || 20;
    // if (!view) view = 20;

    let search = query.search || '';
    // if (!search) search = '';

    return {
      filter,
      page,
      sort,
      orderBy,
      view,
      search,
    };
  }

  handleOnUpdateQueryString() {
    const { filter, page, sort, orderBy, view } = this.parseQueryString();
    if (filter !== this.state.currentFilter) {
      this.setState(
        {
          currentFilter: filter,
        },
        () => this.fetchData()
      );
    }
    if (sort !== this.state.sortFilter) {
      this.setState(
        {
          sortFilter: sort,
        },
        () => this.fetchData()
      );
    }
    if (orderBy !== this.state.orderBy) {
      this.setState(
        {
          orderBy: orderBy,
        },
        () => this.fetchData()
      );
    }
    if (page !== this.state.currentPage) {
      sessionStorage.setItem('current_page', parseInt(page));
      this.setState(
        {
          currentPage: parseInt(page),
        },
        () => this.fetchData()
      );
    }
    if (view !== this.state.viewPerPage) {
      this.handleResetCheckbox(true);
      sessionStorage.setItem('view', parseInt(view));
      this.setState(
        {
          viewPerPage: parseInt(view),
        },
        () => this.fetchData()
      );
    }
  }

  fetchData = async () => {
    this.setState({ loading: true });
    await this.fetchItemsList();
    this.setState({ loading: false });
  };

  fetchItemsList() {
    sessionStorage.setItem('view', parseInt(this.state.viewPerPage));
    sessionStorage.setItem('current_page', parseInt(this.state.currentPage));

    return restRequest(
      'get',
      `woocom/syncHistory/${this.props.match.params.id}?filter=${this.state.currentFilter}&page=${this.state.currentPage}&sort_by=${this.state.sortFilter}&order_by=${this.state.orderBy}&view=${this.state.viewPerPage}`
    )
      .then((res) => {
        let modifiedData = this.prepareDataForTable(
          res?.history?.data,
          res?.currency?.symbol
        );
        this.setState({
          data: modifiedData,
          totalPage: res?.history?.last_page,
          totalRecords: res?.history?.total,
          currency: res?.currency?.symbol,
          currentStore: res?.store,
        });
      })
      .catch((error) => {
        this.setState({
          accessDenied: checkError(error, this.props.handleToast),
        });
      });
  }

  demoData = [
    {
      id: 3,
      itemName: 'Item Name',
      sku: 'sku1',
      oldStock: 1,
      newStock: 1,
    },
    {
      id: 4,
      itemName: 'Item Name 2',
      sku: 'sku 2',
      oldStock: 2,
      newStock: 2,
    },
    {
      id: 5,
      itemName: 'Item Name 3',
      sku: 'sku 3',
      oldStock: 3,
      newStock: 3,
    },
  ];

  prepareDataForTable = (data, symbol) =>
    data.map((item) => ({
      id: item.id,
      'Items Name': {
        id: 'itemName',
        sortable: true,
        getValue: function () {
          return item?.sync_item?.name;
        },
      },
      SKU: {
        id: 'sku',
        sortable: true,
        // alignRight: true,
        getValue: function () {
          return item?.sync_item?.sku;
        },
      },
      'Old Stock': {
        id: 'old_stock',
        //alignRight: true,
        sortable: true,
        getValue: function () {
          return item[this.id];
        },
      },
      'New Stock': {
        id: 'new_stock',
        //  alignRight: true,
        sortable: true,
        getValue: function () {
          return item[this.id];
        },
      },
    }));

  renderTable() {
    const { data, loading, accessDenied } = this.state;
    if (accessDenied) {
      return <AccessDenied type="section" />;
    }
    return (
      <>
        <div
          className={classNames('sync-history-dropdown', 'position-relative')}
        >
          <div className={classNames('sync-history-left')}>
            <div className={classNames('sync-logo')}>
              <img
                src="https://i.ibb.co/JzyLVF2/Woo-Commerce-logo-Woo-Commerce.png"
                alt="Woo-Commerce-logo-Woo-Commerce"
              />&nbsp;/&nbsp;
              <span className='store-name'>
                {this.state.currentStore?.name ||
                  this.state.currentStore?.store_url}
              </span>
            </div>
          </div>
          {/* <div>
            <p className='total-order'>
              Total count of Sale Orders <b>{this.state.totalRecords}</b>
            </p>
          </div> */}
          <div
            className={classNames('close-icon', 'close_icon', 'close-icon-pos')}
            onClick={() =>
              this.props.history.push(
                `/integrations/sync-history/${this.state.currentStore?.id}`
              )
            }
          >
            <MdClose />
          </div>
        </div>
        <ListTable
          data={data}
          linkTo="/sync-history"
          loading={loading}
          isBlur="isActive"
          getID={this.getID}
          moduleName="sync-salesorder-detail"
          totalRecords={this.state.totalRecords}
          tableClass="ecom-sync-table"
          hasCheckbox={false}
          sync
          mapping
          className='sync-item-table mt-10'
        />
      </>
    );
  }

  getID(prevId, id, nextId) {
    let obj = {
      id,
      prevId: prevId ? prevId : null,
      nextId: nextId ? nextId : null,
      moduleName: 'items',
      urlPath: window.location.pathname,
      queryParam: window.location.search,
    };
    setObjInLS('module', obj);
  }

  render() {
    return <>{this.renderTable()}</>;
  }
}

export default HeaderWrapper(
  SyncStockDetails,
  {
    name: 'Sync History',
    tableIcon: 'general_module_icon',
    Icon: NewItemIcon,
    baseUrl: 'items',
    deleteName: 'Item',
    buttonUrl: '/items/add',
    buttonLabel: 'New Item',
    showDetailsComp: false,
    bypassLoadingState: false,
    permissionName: 'item',
    syncHistory: true,
  },
  ItemDetails
);
